import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserFormFieldComponent } from './user-form-field.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule
	],
	declarations: [
		UserFormFieldComponent
	],
	exports: [
		UserFormFieldComponent
	]
})
export class UserFormFieldModule {}
